import { QueryAggregator } from "@/api/utils/QueryAggregator"
import { AccountService } from "@/services/AccountService"

export const hasOpenComplaintOnAccount = (accountNumber: string) => {
  const queries = new QueryAggregator()
  const coreIdQuery = AccountService.getCoreIdByAccountNumber(accountNumber)
  const hasComplaintQuery = AccountService.hasOpenComplaint(coreIdQuery.data)

  queries.add(coreIdQuery)
  queries.add(hasComplaintQuery)

  return queries.setData(hasComplaintQuery.data).getAggregate()
}
